import { Injectable, Type } from '@angular/core';

import { LMListGridComponent } from '@list/lm-list-grid.component';
import { LMListTreeComponent } from '@list/lm-list-tree.component';
import { LMListChartComponent } from '@list/lm-list-chart.component';
import { LMListViewComponent } from '@list/lm-list-view.component';
import { LMListImageComponent } from '@list/lm-list-image.component';
import { LMListHierarchyComponent } from '@list/lm-list-hierarchy.component';
import { LMListContentFilterListComponent } from '@list/lm-list-content-filterlist.component';
import { LMListCubeViewerComponent } from '@list/lm-list-cube-viewer.component';
import { LMListCalendarComponent } from '@list/lm-list-calendar.component';
import { LMListGalleryComponent } from '@app/components';

/** @deprecated move all this into lm-list-spec-util.service.ts */
@Injectable()
export class LMListService {
  private readonly listTypes = {
    list: LMListGridComponent,
    listView: LMListViewComponent,
    filterList: LMListContentFilterListComponent,
    hierarchy: LMListHierarchyComponent,
    chart: LMListChartComponent,
    tree: LMListTreeComponent,
    imageList: LMListImageComponent,
    cubeView: LMListCubeViewerComponent,
    calendar: LMListCalendarComponent,
    gallery: LMListGalleryComponent
  };

  constructor() {}

  public getListByDisplayType(displayType: string): Type<any> {
    return this.listTypes[displayType];
  }
}
